import React from 'react';
var CheckboxListContext = /*#__PURE__*/React.createContext(null);
export default CheckboxListContext;